// Humble Housewives scoring engine
// Pure function: scoreProducts(answers, products) -> { ranked, hasEDP }
//
// answers: { [questionId]: string | string[] }
// products: array of product objects (from data.js HH_PRODUCTS)
// returns:
//   ranked: [{ product, score }] sorted by score desc, featured-first, id-alphabetical
//   hasEDP: boolean — true if any returned product has isEDP === true

(function () {
  "use strict";

  // Question weight multipliers. top_concern dominates; everything else is 1.0.
  const QUESTION_WEIGHTS = {
    top_concern: 1.5,
  };

  function weightFor(questionId) {
    return Object.prototype.hasOwnProperty.call(QUESTION_WEIGHTS, questionId)
      ? QUESTION_WEIGHTS[questionId]
      : 1.0;
  }

  // Does the customer's answer match a given quizScores key answer?
  function answerMatches(customerAnswer, answerId) {
    if (customerAnswer === undefined || customerAnswer === null) return false;
    if (Array.isArray(customerAnswer)) {
      return customerAnswer.indexOf(answerId) !== -1;
    }
    return customerAnswer === answerId;
  }

  function scoreOneProduct(product, answers) {
    let score = 0;
    const scoresMap = product.quizScores || {};
    const keys = Object.keys(scoresMap);
    for (let i = 0; i < keys.length; i++) {
      const key = keys[i];
      const dotIdx = key.indexOf(".");
      if (dotIdx === -1) continue;
      const questionId = key.slice(0, dotIdx);
      const answerId = key.slice(dotIdx + 1);
      const customerAnswer = answers[questionId];
      if (answerMatches(customerAnswer, answerId)) {
        const delta = scoresMap[key];
        score += delta * weightFor(questionId);
      }
    }

    // Hard overrides — applied after accumulation. Rosacea is the strongest.
    // Q5 (dermatologist) is multi-select so its answer is an array — use
    // answerMatches() so the rosacea check still triggers when the customer
    // picked rosacea alongside other diagnoses (e.g. ["rosacea","eczema"]).
    if (answerMatches(answers.dermatologist, "rosacea") && product.rosaceaOverride === true) {
      score = -100;
    } else if (
      answers.reactivity === "very_reactive" &&
      product.reactivityOverride === true
    ) {
      score = -50;
    }

    return score;
  }

  function compareRanked(a, b) {
    // Higher score first
    if (b.score !== a.score) return b.score - a.score;
    // Featured wins ties
    const aFeatured = a.product.featured === true ? 1 : 0;
    const bFeatured = b.product.featured === true ? 1 : 0;
    if (aFeatured !== bFeatured) return bFeatured - aFeatured;
    // Alphabetical id as final tiebreaker
    const aId = String(a.product.id || "");
    const bId = String(b.product.id || "");
    if (aId < bId) return -1;
    if (aId > bId) return 1;
    return 0;
  }

  function scoreProducts(answers, products) {
    const safeAnswers = answers || {};
    const safeProducts = Array.isArray(products) ? products : [];

    // 1. Eligibility filter — exclude bundleEligible: false products
    const eligible = safeProducts.filter(function (p) {
      return p && p.bundleEligible !== false;
    });

    // 2 + 3. Score each eligible product (with overrides applied)
    const scored = eligible.map(function (product) {
      return {
        product: product,
        score: scoreOneProduct(product, safeAnswers),
      };
    });

    // 4. Sort by score desc, featured-first, alphabetical id
    scored.sort(compareRanked);

    // 5. hasEDP flag
    const hasEDP = scored.some(function (entry) {
      return entry.product && entry.product.isEDP === true;
    });

    return { ranked: scored, hasEDP: hasEDP };
  }

  window.scoreProducts = scoreProducts;
})();
